export interface EvidenceWebview {
 getURL():string;
 getAttribute(name:string):string|null;
 executeJavaScript(code:string):Promise<unknown>;
}
/** Read the actual guest, not the configured recipe URL or a shared iframe. */
export async function inspectNativeApp(webview:EvidenceWebview) {
 const url=webview.getURL(),partition=webview.getAttribute('partition') || '';
 if(!url||!partition)throw new Error('App-Nachweis benötigt eine bekannte Browser-Sitzung.');
 const loginMaske=await webview.executeJavaScript(`Boolean(document.querySelector('input[type="password"]'))`);
 if(typeof loginMaske!=='boolean')throw new Error('App-Anmeldung nicht prüfbar.');
 if(loginMaske)throw new Error('Anmeldemaske statt vorbereitetem App-Zugang.');
 if(webview.getURL()!==url)throw new Error('App wechselte während der Prüfung den Bildschirm.');
 return {url,partition,loginMaske};
}
